import React, { Component } from "react";
import { Button, Typography } from "@material-ui/core";
import { GetProductDetails } from "../../../../services";
import AutoSelect from "../../../../common/autoselect";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import swal from "sweetalert";

const Arrays = (data, fieldName, fieldValue) => {
  let arrayItem = [];
  if (data && Array.isArray(data)) {
    data.map((item, key) => {
      arrayItem.push({
        label: ++key + "--" + item[fieldName],
        value: item[fieldValue],
      });
      return null;
    });
  }
  return arrayItem;
};

export default class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getList: [],
      selectedProduct: "",
      isloaded: false,
      limit: 20,
      offset: 0,
      perPage: 30,
      orgtableData: [],
      currentPage: 0,
    };
  }

  handleBack() {
    this.props.history.goBack();
  }

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  }

  async getProductList() {
    this.setState({ isloaded: false });
    let list = await GetProductDetails.getAllProductList();
    if (list) {
      var tdata = list.product;

      var slice = tdata.slice(
        this.state.offset,
        this.state.offset + this.state.perPage
      );
      this.setState({
        pageCount: Math.ceil(tdata.length / this.state.perPage),
        orgtableData: tdata,
        getList: slice,
        isloaded: true,
      });
    }
  }

  async componentDidMount() {
    this.getProductList();
  }

  handleSelectedProduct = async (name, selected) => {
    if (name === "product_id") {
      this.setState({
        list: {
          ...this.state.list,
          [name]: selected.value,
        },
        selectedProduct: selected,
      });
      this.setState({ changed: true });
    }
  };

  async handlDeleteById(id) {
    swal({
      title: "Are you sure?",
      text: "You want to delete this product from the List",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        let value = await GetProductDetails.getDeleteProduct(id);
        if (value) {
          this.getProductList();
        }
      }
    });
  }

  // handleSubmit = async (event) => {
  //   event.preventDefault();
  //   this.setState({ loading: false });
  //   let list = await GetProductDetails.getProductById(
  //     this.state.selectedProduct.value
  //   );
  //   if (list) {
  //     this.setState({ getList: list.data, isloaded: true });
  //   }
  // };


  handleSubmit = async (event) => {
  event.preventDefault();
  this.setState({ loading: false });

  let list = await GetProductDetails.getProductById(
    this.state.selectedProduct.value
  );

  if (list && list.data && list.data.length > 0) {

    // 🔁 map productvariants -> variants
    const formattedData = list.data.map((item) => ({
      ...item,
      variants: item.productvariants || []   // 👈 key fix
    }));

    this.setState({
      getList: formattedData,
      isloaded: true
    });
  }
};


  // Pagination
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
      },
      () => {
        this.loadMoreData();
      }
    );
  };

  loadMoreData() {
    const data = this.state.orgtableData;
    const slice = data.slice(
      this.state.offset,
      this.state.offset + this.state.perPage
    );
    this.setState({
      pageCount: Math.ceil(data.length / this.state.perPage),
      getList: slice,
    });
  }
  // End Pagination

  render() {
    const { getList, selectedProduct, isloaded } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9 col-lg-6">
            <h2 className="mt-30 page-title">Products</h2>
          </div>
          <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
            <Button variant="contained" onClick={(e) => this.handleBack()}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>
        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">
            <a href="index.html">Dashboard</a>
          </li>
          <li className="breadcrumb-item active">Products</li>
        </ol>
        <div className="row justify-content-between">
          <div className="col-lg-12">
            <a href="/admin/product/create" className="add-btn hover-btn">
              Add New
            </a>
          </div>

          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-8 col-md-8">
                <br />
                <AutoSelect
                  className="basic-single"
                  value={selectedProduct}
                  onChange={this.handleSelectedProduct}
                  isSearchable={true}
                  name="product_id"
                  options={Arrays(this.state.orgtableData, "name", "id")}
                />
              </div>
              <div className="col-lg-2 col-md-2">
                <button
                  className="save-btn hover-btn"
                  type="submit"
                  onClick={this.handleSubmit}
                >
                  Search
                </button>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <div className="card card-static-2 mt-30 mb-30">
              <div className="card-title-2">
                <h4>All Products</h4>
              </div>
              <div className="card-body-table">
                <div className="table-responsive">
                  <table className="table ucp-table table-hover">
             <thead>
  <tr>
    <th style={{ minWidth: "80px" }}>Id</th>
    <th style={{ minWidth: "120px" }}>Image</th>
    <th style={{ minWidth: "200px" }}>Name</th>
    <th style={{ minWidth: "180px" }}>Category</th>
    <th style={{ minWidth: "120px" }}>Dimensions</th>
    <th style={{ minWidth: "120px" }}>Stitches</th>
    <th style={{ minWidth: "260px" }}>Variants</th>
    <th style={{ minWidth: "260px" }}>File Name</th>
    <th style={{ minWidth: "120px" }}>Status</th>
    <th style={{ minWidth: "120px" }}>Action</th>
  </tr>
</thead>

                    <tbody>
                      {isloaded
                        ? getList.map((row, index) => (
                            <tr key={index}>
                              <td>{row.id}</td>
                              <td>
                                <div className="cate-img-5">
                                  <img
                                    crossorigin="anonymous"
                                    src={row.photo}
                                    alt="product-name"
                                  />
                                </div>
                              </td>
                              <td>{row.name}</td>
                              <td>
                                {row.categories && row.categories.length > 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "4px",
                                    }}
                                  >
                                    {row.categories.map((cat, idx) => (
                                      <span
                                        key={idx}
                                        className="badge badge-info"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {cat.name}
                                      </span>
                                    ))}
                                  </div>
                                ) : (
                                  "No Category"
                                )}
                              </td>

                              <td>{row.height}</td>
                              <td>{row.stitches}</td>
                              <td>
                                {row.variants && row.variants.length > 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "6px",
                                    }}
                                  >
                                    {row.variants.map((variant, idx) => (
                                      <div
                                        key={idx}
                                        style={{
                                          background: "#f8f9fa",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "13px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <span>{variant.variantName}</span>
                                        <strong>
                                          &#x20B9;{variant.variantPrice}
                                        </strong>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  "No Variants"
                                )}
                              </td>

                              <td>
                                {row.variants && row.variants.length > 0
                                  ? row.variants.map((variant, idx) => (
                                      <div key={idx}>
                                        <div>{variant.variantPath}</div>
                                      </div>
                                    ))
                                  : "No Path"}
                              </td>

                              <td>
                                {row.status === "active" ? (
                                  <span className="badge-item badge-status-success">
                                    {row.status}
                                  </span>
                                ) : (
                                  <span className="badge-item badge-status">
                                    {row.status}
                                  </span>
                                )}
                              </td>
                              <td className="action-btns">
                                <Link
                                  to={{
                                    pathname: `/admin/product/edit`,
                                    state: { row },
                                  }}
                                >
                                  <Typography className="edit-btn">
                                    <i className="fas fa-edit" />
                                  </Typography>
                                </Link>
                                <Typography
                                  className="delete-btn"
                                  onClick={(e) => this.handlDeleteById(row.id)}
                                >
                                  <i className="fas fa-trash-alt" />
                                </Typography>
                              </td>
                            </tr>
                          ))
                        : "Loading..."}
                    </tbody>
                  </table>
                </div>
                <ReactPaginate
                  previousLabel={"prev"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/product/list/index.jsx